// ./src/contexts/CouponTypesContext/CouponTypesContext.tsx
//
// Thin context wrapper around the useCouponTypes hook. All derived data lives in
// the hook itself. See PoliciesContext for the pattern.

import React, { createContext, useContext } from "react";

import { useCouponTypes, UseCouponTypesOptions, UseCouponTypesReturn } from "@/hooks/useCouponTypes";

const CouponTypesContext = createContext<UseCouponTypesReturn | null>(null);

export interface CouponTypesProviderProps extends UseCouponTypesOptions {
  children: React.ReactNode;
}

export const CouponTypesProvider: React.FC<CouponTypesProviderProps> = ({ children, ...options }) => {
  const value = useCouponTypes(options);

  return <CouponTypesContext.Provider value={value}>{children}</CouponTypesContext.Provider>;
};

export const useCouponTypesContext = (): UseCouponTypesReturn => {
  const context = useContext(CouponTypesContext);

  if (!context) {
    throw new Error(
      "useCouponTypesContext must be used within a <CouponTypesProvider>. " +
        "Wrap your component tree with <CouponTypesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalCouponTypesContext = (): UseCouponTypesReturn | null => {
  return useContext(CouponTypesContext);
};
